import React from 'react';
import cn from 'classnames';

import { ProductDetails as Details } from 'components';

import style from '../../SuppliersList.module.scss';

const ProductDetails = ({ product, tiny }) => {
  return (
    <div className={cn(style.product, { [style.tiny]: tiny })}>
      <Details
        product={product}
        tiny={tiny}
        autoSize
        hideQty
      />
    </div>
  );
};

export default ProductDetails;
